<div class="flex-container user-profile" [ngClass]="{'is-dm-licensed': isDMLicensed}">
	<div class="dm-licensed" (click)="dmLicenseStatus()">
		<img class="pwa-logo" [src]="(isDMLicensed)? 'assets/img/dm-logo.svg' : 'assets/img/unlicensed-dm-logo.svg'" />
	</div>
	<div class="profile-user" (click)="toggleUserProfile()">
		<cv-real-time-status></cv-real-time-status>
		<span #initials class="initials" >
			<i #profileButton cvTooltip [tooltipText]="'Profile'" [tooltipPlacement]="'bottom'"
			class="fas fa-user">
		</i>
		</span>
	</div>
	<div class="ml-2 username" (click)="toggleUserProfile()">
		<span *ngIf="meProfile?.firstName">
			<span class="full-name">{{ meProfile.firstName }}&nbsp;{{ meProfile.lastName }}</span>
		</span>
		<i class="dropdown-icon fas fa-2x fa-chevron-down"></i>
	</div>
</div >
<div #userProfile class="cv-user-profile">

	<button *ngIf="errorReport !== null" [cvCopyClipboard]="errorReport" type="button" class="btn btn-warning error-log-to-report">?</button>

	<div class="title">{{ meProfile?.firstName }}&nbsp;{{ meProfile?.lastName }}</div>
	<div class="full-name-field">
		<span class="username"> {{ user?.userName }} </span>
	</div>
	<hr />

	<div class="title">Information</div>
	<div class="field" *ngIf="user?.organizationName">
		Organization:
		{{ user.organizationName ? user.organizationName : 'N/A' }}
	</div>
	<div class="field" *ngIf="meProfile">Company: {{ meProfile.companyName ? meProfile.companyName : 'N/A'}}</div>
	<div class="field">Email: {{ meProfile?.email }}</div>
	<hr *ngIf="meProfile && meProfile?.certifications && meProfile?.certifications.length" />
	<div *ngIf="meProfile && meProfile?.certifications && meProfile?.certifications.length">
		<div class="title">Certification</div>
		<div class="scrollable certification-wrapper">
			<div class="field">You Have {{ meProfile?.certifications?.length }} certifications :</div>
			<div *ngFor="let cert of  meProfile?.certifications; index as i">
				<div class="field"> Type: {{ getCertificationType(cert.type)}}</div>
				<div class="field"> Expiration: {{ cert.expiration | date: 'shortDate' }}</div>
				<div class="field"> Identifier: {{ cert.identifier}}</div>
				<div class="field"> State: {{ cert.state}}</div>
				<div class="field"> FHA: {{ cert.fha? 'Yes': 'No'}}</div>
				<hr *ngIf="meProfile?.certifications?.length !== (i+1)" />
			</div>
		</div>
	</div>
</div>
